import { Helmet } from 'react-helmet';
import { useEffect } from 'react';

function Home() {
    // the home is a self-contained iframe with its own background - suppress
    // the global grain wallpaper here so it can't bleed behind the iframe.
    useEffect(() => {
        document.body.classList.add('home-page');
        return () => document.body.classList.remove('home-page');
    }, []);

    return (
        <>
            <Helmet>
                <title>ojee / software engineer & developer</title>
                <meta name="description" content="Omar Gamal / CSEN graduate, full-stack developer, and software engineer." />
                <link rel="canonical" href="https://ojee.net/" />
                <script type="application/ld+json">{JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Person",
                    "name": "Omar Gamal",
                    "alternateName": "ojee",
                    "url": "https://ojee.net",
                    "jobTitle": "Software Engineer",
                    "description": "CSEN graduate, full-stack developer, and software engineer.",
                    "knowsAbout": ["JavaScript", "React", "Node.js", "Python", "Full-Stack Development"]
                })}</script>
            </Helmet>
            <iframe
                title="ojee.net workspace"
                src="/redesign-demos/orbit/index.html?v=14"
                style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100dvh', border: 0, background: '#0e0d0a', zIndex: 1 }}
            />
        </>
    );
}

export default Home;
